/*
 * Stores the visitor IP as a private Shopify line-item property. Properties
 * beginning with an underscore are retained in Shopify Admin order details,
 * but are hidden from customer-facing cart and checkout views.
 */
(function (window, document) {
  'use strict';

  var propertyNames = { ipv4: '_Customer IPv4', ipv6: '_Customer IPv6' };
  var ipsPromise;
  var availableIps = { ipv4: '', ipv6: '' };

  function fetchIp(url) {
    var controller = new AbortController();
    var timeout = window.setTimeout(function () { controller.abort(); }, 3000);
    return fetch(url, { cache: 'no-store', signal: controller.signal })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to retrieve IP address');
        return response.json();
      })
      .then(function (data) { return data && typeof data.ip === 'string' ? data.ip : ''; })
      .catch(function () { return ''; })
      .then(function (ip) {
        window.clearTimeout(timeout);
        return ip;
      });
  }

  function getAllIps() {
    if (!ipsPromise) {
      var ipv4Request = fetchIp('https://api.ipify.org?format=json').then(function (ip) {
        availableIps.ipv4 = ip.indexOf('.') !== -1 && ip.indexOf(':') === -1 ? ip : '';
        populateProductForms();
        return availableIps.ipv4;
      });
      var ipv6Request = fetchIp('https://api6.ipify.org?format=json').then(function (ip) {
        availableIps.ipv6 = ip.indexOf(':') !== -1 ? ip : '';
        populateProductForms();
        return availableIps.ipv6;
      });
      ipsPromise = Promise.all([ipv4Request, ipv6Request]).then(function () { return availableIps; });
    }
    return ipsPromise;
  }

  function getProperties(ips) {
    var properties = {};
    if (ips.ipv4) properties[propertyNames.ipv4] = ips.ipv4;
    if (ips.ipv6) properties[propertyNames.ipv6] = ips.ipv6;
    return properties;
  }

  function addPropertiesToForm(form, ips) {
    if (!form) return;
    var properties = getProperties(ips);
    Object.keys(properties).forEach(function (key) {
      var fieldName = 'properties[' + key + ']';
      var field = form.querySelector('input[name="' + fieldName + '"]');
      if (!field) {
        field = document.createElement('input');
        field.type = 'hidden';
        field.name = fieldName;
        form.appendChild(field);
      }
      field.value = properties[key];
    });
  }

  function addPropertiesToRequest(data, ips) {
    var properties = getProperties(ips);
    Object.keys(properties).forEach(function (key) {
      data['properties[' + key + ']'] = properties[key];
    });
  }

  function isProductForm(form) {
    return form && form.tagName === 'FORM' && form.querySelector('[name="id"]');
  }

  function populateProductForms() {
    Array.prototype.forEach.call(document.querySelectorAll('form'), function (form) {
      if (isProductForm(form)) addPropertiesToForm(form, availableIps);
    });
  }

  window.lineItemIp = {
    getAll: getAllIps,
    getAvailable: function () { return availableIps; },
    getProperties: getProperties,
    addPropertiesToForm: addPropertiesToForm,
    addPropertiesToRequest: addPropertiesToRequest,
    propertyNames: propertyNames
  };

  // Start lookup immediately, but never hold up Add to Cart for it.
  getAllIps();

  // Theme shortcuts use Shopify.addItem rather than a product form. Wrap that
  // helper so collection, gift, cross-sell, and upsell buttons are covered too.
  function wrapShopifyAddItem() {
    if (!window.Shopify || !window.Shopify.addItem || window.Shopify.addItem.lineItemIpWrapped) return;

    var wrappedAddItem = function (variantId, quantity, callback, properties) {
      var itemProperties = properties || {};
      var ipProperties = getProperties(availableIps);
      Object.keys(ipProperties).forEach(function (key) { itemProperties[key] = ipProperties[key]; });

      var data = { id: variantId, quantity: quantity };
      Object.keys(itemProperties).forEach(function (key) {
        data['properties[' + key + ']'] = itemProperties[key];
      });

        // Shopify's legacy addItem helper does not consistently support a
        // properties argument, so submit the documented Ajax Cart payload here.
      window.jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: callback,
        error: window.Shopify.onError
      });
    };
    wrappedAddItem.lineItemIpWrapped = true;
    window.Shopify.addItem = wrappedAddItem;
  }

  wrapShopifyAddItem();
  document.addEventListener('DOMContentLoaded', wrapShopifyAddItem);
})(window, document);
